// extracted by mini-css-extract-plugin
export default {"loader":"ProgressSpinner_loader__Wzm8g"};